import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'

const blogPosts = [
  { id: '1', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-homs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
  { id: '2', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-steve-jobs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
  { id: '3', title: 'Fly High With Our Exclusive Travel Tips', image: '/investment-wealth.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
]

export default function Home() {
  return (
    <>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 1 — HERO
          BG: Pure black #000
          Left: text aligned to left with padding
          Center: "Ch" outline watermark
          Right: Photo fades into black on all edges
          Bottom-right: orange round chat bubble
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section
        className="relative w-full overflow-hidden flex items-center"
        style={{ height: 'calc(100vh - 72px)', minHeight: '580px', background: '#000' }}
      >
        {/* Photo — right side, fades into black on ALL edges */}
        <div className="absolute right-0 top-0 bottom-0" style={{ width: '55%' }}>
          <img
            src="/ghassan-real.jpg"
            alt="Ghassan"
            className="w-full h-full object-cover object-center"
          />
          {/* left fade */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, #000 0%, rgba(0,0,0,0.85) 18%, rgba(0,0,0,0.4) 45%, transparent 75%)' }} />
          {/* right fade */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(270deg, #000 0%, rgba(0,0,0,0.65) 10%, transparent 35%)' }} />
          {/* top fade */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #000 0%, rgba(0,0,0,0.5) 10%, transparent 30%)' }} />
          {/* bottom fade */}
          <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, #000 0%, rgba(0,0,0,0.5) 10%, transparent 30%)' }} />
        </div>

        {/* "Ch" outline watermark — center overlap area */}
        <div className="absolute pointer-events-none select-none" style={{
          top: '50%', left: '33%', transform: 'translateY(-52%)',
          fontSize: '380px', fontWeight: 900, lineHeight: 1,
          color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.08)',
          whiteSpace: 'nowrap', zIndex: 2,
        }}>Ch</div>

        {/* Chat bubble */}
        <div className="absolute z-20 flex items-center justify-center rounded-full" style={{
          bottom: '32px', right: '32px', width: '54px', height: '54px',
          background: '#f97316', boxShadow: '0 4px 20px rgba(249,115,22,0.5)',
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>

        {/* Text — left */}
        <div className="relative z-10 w-full" style={{ paddingLeft: '56px', paddingRight: '56px' }}>
          <div style={{ maxWidth: '500px' }}>
            <h1 style={{
              fontSize: '62px', fontWeight: 900, lineHeight: 1.0,
              letterSpacing: '0.01em', color: 'rgba(190,205,228,0.95)',
              marginBottom: '6px',
            }}>ALRIFAI</h1>

            <p style={{
              fontSize: '20px', fontWeight: 800,
              color: '#f97316', letterSpacing: '0.04em',
              marginBottom: '24px',
            }}>TOGETHER, WE ALL WIN</p>

            <p style={{
              fontSize: '15px', lineHeight: 1.85,
              color: 'rgba(255,255,255,0.78)',
              maxWidth: '460px', marginBottom: '44px',
            }}>
              Join Ghassan Al Rifai On His Inspiring Journey And Learn How His Unique Approach To Leadership
              And Belief In Collective Achievement Have Shaped A New Era Of Business Success.
            </p>

            {/* Slider indicator: orange dash + 3 small dots */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '36px', height: '4px', borderRadius: '2px', background: '#f97316' }} />
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(255,255,255,0.28)' }} />
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(255,255,255,0.28)' }} />
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(255,255,255,0.28)' }} />
            </div>
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 2 — GHASSAN BIO
          BG: Dark charcoal-grey #252830 with Arabic calligraphy pattern
          Left: Ghassan sticker photo (colorful irregular outline)
          Right: "GHASSAN" bold + paragraph
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section className="relative overflow-hidden" style={{ background: '#252830', minHeight: '520px' }}>
        {/* Arabic calligraphy bg pattern */}
        <div className="absolute inset-0" style={{
          backgroundImage: 'url(/arab-pattern-bg.jpg)',
          backgroundSize: 'cover', backgroundPosition: 'center',
          opacity: 0.20, zIndex: 0,
        }} />

        <div className="relative z-10 max-w-6xl mx-auto px-10 py-20">
          <div className="grid md:grid-cols-2 gap-12 items-center">

            {/* Left: sticker-style photo with colorful jagged outline */}
            <div style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '20px' }}>
              <div style={{ position: 'relative', width: '300px', height: '340px' }}>
                {/* Colorful glow — conic gradient mimics the colorful sticker border */}
                <div style={{
                  position: 'absolute', inset: '-4px',
                  background: 'conic-gradient(from 0deg, #fff 0deg, #4ade80 40deg, #818cf8 90deg, #f472b6 140deg, #fb923c 180deg, #fff 220deg, #22d3ee 270deg, #a3e635 320deg, #fff 360deg)',
                  clipPath: 'polygon(50% 0%, 58% 3%, 65% 0%, 72% 5%, 80% 2%, 86% 8%, 93% 6%, 98% 12%, 100% 20%, 97% 28%, 100% 36%, 98% 44%, 100% 52%, 97% 60%, 99% 68%, 95% 75%, 98% 82%, 93% 88%, 88% 93%, 80% 97%, 73% 100%, 65% 97%, 57% 100%, 49% 97%, 41% 100%, 33% 97%, 25% 100%, 17% 96%, 10% 92%, 5% 85%, 2% 77%, 0% 68%, 3% 60%, 0% 52%, 2% 44%, 0% 36%, 3% 28%, 0% 20%, 4% 12%, 9% 6%, 16% 2%, 23% 5%, 30% 1%, 38% 4%)',
                  zIndex: 0,
                }} />
                {/* White inner layer */}
                <div style={{
                  position: 'absolute', inset: '2px',
                  background: '#fff',
                  clipPath: 'polygon(50% 0%, 58% 3%, 65% 0%, 72% 5%, 80% 2%, 86% 8%, 93% 6%, 98% 12%, 100% 20%, 97% 28%, 100% 36%, 98% 44%, 100% 52%, 97% 60%, 99% 68%, 95% 75%, 98% 82%, 93% 88%, 88% 93%, 80% 97%, 73% 100%, 65% 97%, 57% 100%, 49% 97%, 41% 100%, 33% 97%, 25% 100%, 17% 96%, 10% 92%, 5% 85%, 2% 77%, 0% 68%, 3% 60%, 0% 52%, 2% 44%, 0% 36%, 3% 28%, 0% 20%, 4% 12%, 9% 6%, 16% 2%, 23% 5%, 30% 1%, 38% 4%)',
                  zIndex: 1,
                }} />
                {/* Photo */}
                <img
                  src="/ghassan-artistic.jpg"
                  alt="Ghassan"
                  style={{
                    position: 'absolute', inset: '4px',
                    width: 'calc(100% - 8px)', height: 'calc(100% - 8px)',
                    objectFit: 'cover', objectPosition: 'center top',
                    clipPath: 'polygon(50% 0%, 58% 3%, 65% 0%, 72% 5%, 80% 2%, 86% 8%, 93% 6%, 98% 12%, 100% 20%, 97% 28%, 100% 36%, 98% 44%, 100% 52%, 97% 60%, 99% 68%, 95% 75%, 98% 82%, 93% 88%, 88% 93%, 80% 97%, 73% 100%, 65% 97%, 57% 100%, 49% 97%, 41% 100%, 33% 97%, 25% 100%, 17% 96%, 10% 92%, 5% 85%, 2% 77%, 0% 68%, 3% 60%, 0% 52%, 2% 44%, 0% 36%, 3% 28%, 0% 20%, 4% 12%, 9% 6%, 16% 2%, 23% 5%, 30% 1%, 38% 4%)',
                    zIndex: 2,
                  }}
                />
              </div>
            </div>

            {/* Right: text */}
            <div>
              <h2 style={{ fontSize: '32px', fontWeight: 900, color: '#fff', letterSpacing: '0.1em', marginBottom: '20px' }}>
                GHASSAN
              </h2>
              <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.9 }}>
                Ghassan Alrifai, A Visionary Entrepreneur, Has Pioneered Innovative Solutions And
                Driven Sustainable Growth Through His Expertise In Technology, Sales, And Strategic Planning
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 3 — THE STORY
          BG: Very dark navy #090d18 — nearly black with blue tint
          Orange heading, 2 cards side by side
          Each card: image top, text below, subtle border
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section style={{ background: '#090d18', padding: '80px 0' }}>
        <div className="max-w-6xl mx-auto px-10">
          <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#f97316', textAlign: 'center', marginBottom: '48px', letterSpacing: '0.02em' }}>
            The Story Behind Ghassan Alrifai
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            {[
              { img: '/story-event.jpg' },
              { img: '/ghassan-real.jpg' },
            ].map((card, i) => (
              <div key={i} style={{ border: '1px solid rgba(255,255,255,0.07)', borderRadius: '6px', overflow: 'hidden', background: 'rgba(255,255,255,0.02)' }}>
                <img src={card.img} alt="" style={{ width: '100%', height: '180px', objectFit: 'cover' }} />
                <div style={{ padding: '18px' }}>
                  <p style={{ fontSize: '11.5px', color: 'rgba(255,255,255,0.58)', lineHeight: 1.85 }}>
                    Ghassan Al-Rifai's Journey Highlights His Relentless Drive And Innovation. With Expertise In Business Development, Technology, And Strategic Planning, He Is Committed To Collaboration And Spotting Opportunities, Fueling His Mission To Empower Future Innovators.
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 4 — BUSINESS
          BG: Pure dark #060810 — deepest section
          White "BUSINESS" title centered, subtext
          3 white-background logo cards
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section style={{ background: '#060810', padding: '80px 0' }}>
        <div className="max-w-5xl mx-auto px-10">
          <h2 style={{ fontSize: '22px', fontWeight: 900, color: '#fff', textAlign: 'center', letterSpacing: '0.18em', marginBottom: '12px' }}>
            BUSINESS
          </h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.48)', textAlign: 'center', lineHeight: 1.8, maxWidth: '440px', margin: '0 auto 48px' }}>
            Al Mohammad Ghassan Alrifai, The Focus Is On New And Exciting Projects That Will Be Revealed Soon, Aiming To Create Solutions For The Future.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', maxWidth: '640px', margin: '0 auto' }}>
            {[
              { name: 'Veteran General Contracting' },
              { name: 'Treasure Deal Invest' },
              { name: 'Treasure Deal Group' },
            ].map((p, i) => (
              <div key={i} style={{ borderRadius: '6px', overflow: 'hidden', border: '1px solid rgba(20,40,100,0.7)' }}>
                <div style={{ background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '88px', padding: '10px' }}>
                  <img src="/placeholder-logo.png" alt={p.name} style={{ maxHeight: '56px', maxWidth: '100%', objectFit: 'contain' }} />
                </div>
                <div style={{ background: 'rgba(8,16,52,0.85)', padding: '10px 12px' }}>
                  <div style={{ fontSize: '11px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>{p.name}</div>
                  <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.38)' }}>By</div>
                  <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.38)' }}>Mr. Mohammad Ghassan A Al Rifai</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 5 — GHASSAN VISION
          BG: Dark navy #0b1020 — slightly lighter than business
          "Ghassan Vision" orange italic-style heading
          Paragraph text centered
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section style={{ background: '#0b1020', padding: '80px 0' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto', padding: '0 40px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#f97316', marginBottom: '24px' }}>
            Ghassan Vision
          </h2>
          <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.62)', lineHeight: 2.0 }}>
            Ghassan Al Rifai's Vision Is All About Empowering Entrepreneurs And Creating A Lively Environment Of Innovation And Growth. He Believes In The Power Of Collaboration And Mutual Success, Aiming To Build Win-Win Partnerships And Foster Relationships That Drive Collective Growth.
          </p>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 6 — GHASSAN MISSION
          BG: Slightly lighter dark #0f1520
          White heading, paragraph centered
          3 cards: orange icon ring, bold title, desc text, orange filled circle bottom
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section style={{ background: '#0f1520', padding: '80px 0' }}>
        <div className="max-w-6xl mx-auto px-10">
          <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#fff', textAlign: 'center', marginBottom: '20px' }}>
            Ghassan Mission
          </h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.95, maxWidth: '720px', margin: '0 auto 52px', textAlign: 'center' }}>
            Ghassan Alrifai's Mission Is Clear, He Supports Aspiring Entrepreneurs From His Extensive Experience Across Diverse Industries. He Also Invests In Promising Startups And Disruptive Technologies, Providing Essential Capital And Expertise To Fuel Their Success And Contribute To A Thriving Future. Ultimately, He Wants To Leave A Legacy Of Positive Impact, Empowering Entrepreneurs And Nurturing A Culture Of Innovation And Progress.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
            {[
              {
                icon: (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
                  </svg>
                ),
                title: 'Investment and Support',
                desc: 'Invest Venture capital and disruptive technologies with critical capital and expertise to fuel their success and contribute to a thriving future.',
              },
              {
                icon: (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round">
                    <circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/>
                  </svg>
                ),
                title: 'Mentorship and Guidance',
                desc: 'Invest Venture capital and strategic guidance to emerging entrepreneurs, utilizing extensive experience across various industries.',
              },
              {
                icon: (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                ),
                title: 'Legacy of Impact',
                desc: 'Invest Venture capital and strategic guidance to emerging entrepreneurs, utilizing extensive experience across various industries.',
              },
            ].map((c, i) => (
              <div key={i} style={{ background: 'rgba(255,255,255,0.025)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '10px', padding: '28px 24px' }}>
                {/* Icon circle */}
                <div style={{ width: '50px', height: '50px', borderRadius: '50%', background: 'rgba(249,115,22,0.10)', border: '1.5px solid rgba(249,115,22,0.40)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '18px' }}>
                  {c.icon}
                </div>
                <h3 style={{ fontSize: '13.5px', fontWeight: 700, color: '#fff', marginBottom: '12px' }}>{c.title}</h3>
                <p style={{ fontSize: '11.5px', color: 'rgba(255,255,255,0.48)', lineHeight: 1.85 }}>{c.desc}</p>
                {/* Orange filled circle */}
                <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
                  <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#fff' }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 7 — CORE VALUES
          BG: Dark #0c0f1c with faint horizontal stripe texture + left orange bar
          "CORE VALUES" white uppercase heading
          Long desc paragraph centered
          3 columns: orange icon ring, ORANGE LABEL uppercase, desc, orange dot circle
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section className="relative overflow-hidden" style={{ background: '#0c0f1c', padding: '80px 0' }}>
        {/* Horizontal stripe texture */}
        <div className="absolute inset-0 pointer-events-none" style={{
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 38px, rgba(255,255,255,0.018) 38px, rgba(255,255,255,0.018) 39px)',
          zIndex: 0,
        }} />
        {/* Left orange vertical bar */}
        <div className="absolute left-0 top-0 bottom-0" style={{ width: '4px', background: 'linear-gradient(180deg, transparent 5%, #f97316 30%, #f97316 70%, transparent 95%)', zIndex: 1 }} />

        <div className="relative z-10 max-w-5xl mx-auto px-10">
          <h2 style={{ fontSize: '22px', fontWeight: 900, color: '#fff', textAlign: 'center', letterSpacing: '0.18em', marginBottom: '16px' }}>
            CORE VALUES
          </h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.52)', lineHeight: 1.95, maxWidth: '680px', margin: '0 auto 56px', textAlign: 'center' }}>
            Ghassan Alrifai's Core Values Are At The Heart Are Collaboration, Innovation, Growth, And Impact. He Believes In The Power Of Partnership And Shared Success, He Is Committed To Embracing New Ideas And Pioneering Cutting-Edge Solutions, Dedicated To Nurturing Both Individual And Collective Development, And Strive To Make A Meaningful Difference In The Entrepreneurial Landscape.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '32px', maxWidth: '680px', margin: '0 auto' }}>
            {[
              {
                icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
                label: 'COLLABORATION',
                desc: 'Harnessing The Power Of Partnerships To Accomplish Mutual Business.',
              },
              {
                icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>,
                label: 'INNOVATION',
                desc: 'Committed To Advancing New Ideas And Cutting-Edge Solutions.',
              },
              {
                icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>,
                label: 'GROWTH',
                desc: 'Focusing On Nurturing Both Individual And Shared Development.',
              },
            ].map((v, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                {/* Icon ring */}
                <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(249,115,22,0.10)', border: '2px solid rgba(249,115,22,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
                  {v.icon}
                </div>
                {/* Orange label */}
                <div style={{ fontSize: '12px', fontWeight: 800, color: '#f97316', letterSpacing: '0.12em', marginBottom: '10px' }}>{v.label}</div>
                {/* Desc */}
                <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.48)', lineHeight: 1.85 }}>{v.desc}</p>
                {/* Orange circle dot */}
                <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '16px auto 0' }}>
                  <div style={{ width: '9px', height: '9px', borderRadius: '50%', background: '#fff' }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
          SECTION 8 — FROM HIS BLOG
          BG: Medium dark #14171f with subtle pattern overlay (dimmed)
          White heading + subtext
          3 blog cards — dark blue-border style
      ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */}
      <section className="relative overflow-hidden" style={{ background: '#14171f', padding: '80px 0' }}>
        {/* Subtle texture */}
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'url(/arab-pattern-bg.jpg)', backgroundSize: 'cover', opacity: 0.06, zIndex: 0 }} />
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'rgba(18,20,28,0.78)', zIndex: 0 }} />

        <div className="relative z-10 max-w-6xl mx-auto px-10">
          <h2 style={{ fontSize: '22px', fontWeight: 800, color: '#fff', textAlign: 'center', marginBottom: '12px' }}>
            From His Blog
          </h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.48)', textAlign: 'center', lineHeight: 1.85, maxWidth: '520px', margin: '0 auto 48px' }}>
            Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects. Stay Updated With Content Relevant To You.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            {blogPosts.map(post => <BlogCard key={post.id} {...post} />)}
          </div>
        </div>
      </section>

      {/* Newsletter + Footer */}
      <NewsletterSection />
    </>
  )
}
